import React, {Component} from 'react'
import propTypes from 'prop-types'
import {isEmpty, isNil} from "lodash"
import theme from 'theme/index'
import themeVars from 'theme/themeVars'
import {t} from 'helpers/language'
import FileSelect from 'components/fileSelect'
import Snackbar from 'components/snackbar'
import Placeholder from 'components/placeholder'

const getStyles = (state, props) => {
  const propStyles = props.styles || {}
  const styles = {
    container: {
      position: 'relative',
      width: '100%',
    },
    uploadArea: {
      position: 'absolute',
      backgroundColor: themeVars.palette.primary3Color,
      border: `2px solid ${themeVars.palette.primary1Color}`,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: '0.8',
      transition: 'background-color 0.3s linear',
      zIndex: 99,
    },
    fileSelect: {
      display: 'none',
    },
  }
  return {...styles, ...propStyles}
}

class FileUploader extends Component {
  state = {
    isDragging: false,
  }

  onAllowDrop = (event) => {
    event.preventDefault()
  }

  onDragLeave = (event) => {
    event.preventDefault()
    this.onHideFileUploadArea()
  }

  onDrop = (event) => {
    const {onFileUpload} = this.props

    event.preventDefault()
    const files = event.target.files || event.dataTransfer.files
    onFileUpload(files)
    this.onHideFileUploadArea()
  }

  onShowFileUploadArea = () => {
    const {isDragging} = this.state
    if (!isDragging) {
      this.setState({isDragging: true})
    }
  }

  onHideFileUploadArea = () => {
    const {isDragging} = this.state
    if (isDragging) {
      this.setState({isDragging: false})
    }
  }

  onFileChange = () => {
    const fileUpload = this.input
    if ('files' in fileUpload) {
      if (!isEmpty(fileUpload.files)) {
        this.onFileUpload(fileUpload.files)
      }
    }
  }

  onFileUpload = (files) => {
    const {onFileUpload} = this.props

    onFileUpload(files)

    const fileUpload = this.input
    try {
      fileUpload.files = []
    } catch {
    }
  }

  selectFile = () => {
    this.fileSelect.open()
  }

  render() {
    const {
      children,
      disabled,
      dropLabel,
      placeholderBackgroundColor,
      placeholderButtonLabel,
      placeholderIcon,
      placeholderIconColor,
      placeholderIconSize,
      placeholderMessage,
      showPlaceholder,
    } = this.props
    let {multiple} = this.props
    const {isDragging} = this.state

    const styles = getStyles(this.state, this.props)
    const dragAndDropFilesUploadAreaStyles = isDragging ? styles.uploadArea : {}

    let placeholder
    if (showPlaceholder) {
      const actionClassName = isNil(placeholderButtonLabel)
        ? null
        : placeholderButtonLabel.split(' ').join('-').toLowerCase()

      const data = {
        backgroundColor: placeholderBackgroundColor,
        height: 250,
        iconColor: placeholderIconColor,
        iconSize: placeholderIconSize,
        messageIcon: !isNil(placeholderIcon) ? placeholderIcon : theme.icons.upload,
        messageTitle: placeholderMessage,
        actions: [{
          title: placeholderButtonLabel,
          className: actionClassName,
          onClick: this.selectFile,
        }],
      }
      placeholder = <Placeholder {...data} />
    }

    if (!multiple) multiple = null

    let select, input, containerDragOver, dragOver, dragLeave, drop
    if (!disabled) {
      select = (
        <FileSelect
          ref={e => {
            this.fileSelect = e
          }}
          multiple={multiple}
          onSelect={this.onFileUpload}
        />
      )
      input = (
        <input
          multiple={multiple}
          name={"fileselect[]"}
          onChange={this.onFileChange}
          ref={e => {
            this.input = e
          }}
          style={styles.fileSelect}
          type={"file"}
        />
      )
      containerDragOver = this.onShowFileUploadArea
      dragOver = this.onAllowDrop
      dragLeave = this.onDragLeave
      drop = this.onDrop
    }

    return (
      <div className={"fileUploader-container"} style={styles.container} onDragOver={containerDragOver}>
        <>
          {placeholder}
          {children}
        </>
        {select}
        <div
          className={"fileUploader-uploadArea"}
          style={dragAndDropFilesUploadAreaStyles}
          onDragOver={dragOver}
          onDragLeave={dragLeave}
          onDrop={drop}
        >
          {input}
        </div>
        <Snackbar
          open={isDragging}
          message={t(dropLabel)}
          icon={theme.icons.upload}
          iconColor={themeVars.palette.whiteColor}
          autoHide={false}
          allowClose={false}
        />
      </div>
    )
  }
}

FileUploader.propTypes = {
  children: propTypes.any,
  disabled: propTypes.bool,
  dropLabel: propTypes.string,
  multiple: propTypes.bool,
  onFileUpload: propTypes.func.isRequired,
  placeholderBackgroundColor: propTypes.string,
  placeholderButtonLabel: propTypes.string,
  placeholderIcon: propTypes.string,
  placeholderIconColor: propTypes.string,
  placeholderIconSize: propTypes.number,
  placeholderMessage: propTypes.string,
  showPlaceholder: propTypes.bool,
}

FileUploader.defaultProps = {
  disabled: false,
  dropLabel: 'Drop your file(s) here to upload them',
  multiple: false,
  placeholderButtonLabel: 'Select files to upload',
  placeholderIcon: null,
  placeholderMessage: 'Drag and drop files here to upload them',
}

export default FileUploader
